import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'lodash';

import './MarketsContainer.scss';
import RacingDetailContext from '../Context/RacingDetail.context';
import SimpleTabs from '../../../components/SimpleTabs/SimpleTabs';
import MarketsRow from './MarketsRow/MarketsRow';
import MarketsStake from './MarketsStake/MarketsStake';
import Button from '../../../components/Button/Button';
import { RaceMarket } from 'src/interfaces/RacingState';
import { checkIfCrossEvent } from 'src/utils/racingCombinations';

export default function MarketsContainer() {
  const { t } = useTranslation('common');
  const history = useHistory();
  const location = useLocation();

  const { event, selectedMarket, setSelectedHorsePosition, setShowCompetitors, showCompetitors } = useContext(RacingDetailContext);
  const [defaultTab, setDefaultTab] = useState(0);

  const isPickMarket = selectedMarket && checkIfCrossEvent(selectedMarket);
  const fixedOddsMarkets =  _.filter(event.markets, { oddsType: 3 });
  const toteMarkets = _.filter(event.markets, { oddsType: 2 });

  const currentLabels = [];
  if (!_.isEmpty(fixedOddsMarkets)) {
    currentLabels.push({ label: t('racingDetail.fixedOdds') });
  }
  if (!_.isEmpty(toteMarkets)) {
    currentLabels.push({ label: t('racingDetail.tote') });
  }

  useEffect(() => {
    if (selectedMarket?.oddsType === 2 && !_.isEmpty(fixedOddsMarkets)) {
      setDefaultTab(1);
    } else {
      setDefaultTab(0);
    }
  }, [selectedMarket]);

  const onMarketChange = (market: RaceMarket) => {
    const uri = location.search ? `/racing/${ event.meetingCode }/${ event.eventCode }/all/${ market.code }${ location.search }`
      : `/racing/${ event.meetingCode }/${ event.eventCode }/all/${ market.code }`;

    history.push(uri);
  };

  const onTabChange = (e, tab) => {
    if (tab === 0 && !_.isEmpty(fixedOddsMarkets)) {
      onMarketChange(fixedOddsMarkets[0]);
    } else {
      onMarketChange(toteMarkets[0]);
    }
  };

  const toggleShowCompetitors = () => {
    if ((showCompetitors.open > 0 && showCompetitors.open < showCompetitors.total) || showCompetitors.open === 0) { //opening, open > 0 < total || open === 0
      setShowCompetitors({
        ...showCompetitors,
        show: true,
        open: showCompetitors.total
      });
    } else if (showCompetitors.open === showCompetitors.total) { // closing, open equals total
      setShowCompetitors({
        ...showCompetitors,
        show: false,
        open: 0
      });
    }
  };

  return (
    <div className="markets-container">
      <SimpleTabs
        key={ event?.raceNo + defaultTab }
        labels={ currentLabels }
        showIndicator={ false }
        variant="fullWidth"
        defaultTab={ defaultTab }
        onChange={ onTabChange }
      >
        {
          !_.isEmpty(fixedOddsMarkets) &&
          <div className="markets-container__markets-wrapper">
            <MarketsRow markets={ fixedOddsMarkets } onMarketChange={ onMarketChange } />
          </div>
        }
        {
          !_.isEmpty(toteMarkets) &&
          <div className="markets-container__markets-wrapper">
            <MarketsRow markets={ toteMarkets } onMarketChange={ onMarketChange } />
          </div>
        }
      </SimpleTabs>
      {
        isPickMarket &&
          <div className="markets-container__clear-container">
            <Button onClick={ toggleShowCompetitors } className="markets-container_open-all">
              {
                (showCompetitors.open === showCompetitors.total)
                  ?
                  t('racingDetail.closeAll')
                  :
                  t('racingDetail.openAll')
              }
            </Button>
            <div className="markets-container__clear-btn" onClick={ () => setSelectedHorsePosition([]) }>
              <span>{ t('racingDetail.clearAll') }</span>
            </div>
          </div>
      }
      { !isPickMarket && <MarketsStake /> }
    </div>
  );
}
